<template>
  <v-container>
    <v-app-bar app color="primary" dark >
      <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title v-text="$store.state.pageTitle"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark class='primary darken-2' icon @click="createProduct">
        <v-icon >mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>

    <v-data-table :headers="headers" :items="products" hide-default-footer pagination.sync="pagination" >
      <template v-slot:item.image1="{ item }">
        <div class="py-2" v-if="item.image1">
          <v-img :src="`${$store.state.apiUrl}static/images/thumb/${item.image1}`" :width="80" :aspect-ratio="4/3"></v-img>
        </div>
      </template>
      <template v-slot:item.price="{ item }">
        {{ $toMoney(item.price) }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn icon class="mr-3" @click="editProduct(item)">
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="deleteProduct(item.id)">
          <v-icon color="warning">mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <ProductDialog ref="product" @closeDialog="closeDialogProduct"></ProductDialog>

  </v-container>
</template>

<script>
  import ProductDialog from '@/components/nano/ProductDialog'
  export default {
    components: { ProductDialog },

    data(){
      return {
        headers: [
          { text: 'Image', value: 'image1', sortable: false },
          { text: 'Name', value: 'name', sortable: false },
          { text: 'Description', value: 'description', sortable: false },
          { text: 'Price', value: 'price', align: 'end', sortable: false },
          { text: 'Action', value: 'action', align: 'end', sortable: false },
        ],
      }
    },

    computed:{
      products(){
        return this.$store.state.products
      }
    },


    methods:{

      toggleDrawer(){
        this.$store.commit('mutate', { prop: 'drawer', data: !this.$store.state.drawer })
      },
      getProducts(){
        this.axios.get('products').then( (res) => {
          this.$store.commit('mutate', { prop: 'products', data: res.data })
        }).catch( (err) => {
          console.log(err)
        })
      },
      createProduct(){
        this.$refs.product.dialogProduct = true
      },
      closeDialogProduct(){
        this.$refs.product.dialogProduct = false
        this.$refs.product.product = { description: '' }
      },
      editProduct(product){
        this.$refs.product.product = Object.assign({}, product)
        this.$refs.product.dialogProduct = true
      },

      deleteProduct(id){
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.axios.delete('/products/' + id).then( () => {
              this.getProducts()
              this.$store.commit('mutate', { prop: 'snackbar', data: { text: 'Deleted!', value:true } })
            }).catch(err => {
              this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
            })
          }
        })
      }

    }
  }
</script>

<style scoped>
</style>